import React, { useEffect } from "react";
import { Switch, Route, Redirect, useHistory, useLocation } from 'react-router-dom';

import StandRoutes from "./stand-routes";
import MoreRoutes from "./more-routes";
import { Pages } from "components/pages";
import { useMe, useFilterStorage } from "components/use-hooks";
import { UserHelpers } from "components/user";
import { checkUser } from "utils";

const { permission } = UserHelpers;
const { getUserPermissions, hasRealActiveEvent } = checkUser;


const AppRoutes = () => {
    const { me } = useMe();
    const filterStorage = useFilterStorage();
    const { hasActiveEvent } = checkUser;
    const history = useHistory();
    const location = useLocation();

    if (hasActiveEvent(me))
    {
        filterStorage.restore("all");
    }

    const { isLimitedUser } = getUserPermissions(me);

    const hasActiveEventForUser = hasRealActiveEvent(me);

    useEffect(() => {
        if (!hasActiveEventForUser && location.pathname === '/')
        {
            history.replace('/exhibitions');
        }
    }, [ hasActiveEventForUser, location.pathname, history ]);

    if (isLimitedUser)
    {
        return (
            <Switch>
                <Route path="/exhibitions" exact>
                    <Pages.Exhibitions />
                </Route>
                <Route path="/" exact>
                    { !hasActiveEventForUser ? <Redirect to="/exhibitions" /> : <Pages.Home /> }
                </Route>
                <Route path="/more/">
                    <MoreRoutes />
                </Route>
                <Route path="*">
                    <Redirect to={ hasActiveEventForUser ? "/" : "/exhibitions" } />
                </Route>
            </Switch>
        );
    }

    return (
        <Switch>
            <Route path="/exhibitions" exact>
                <Pages.Exhibitions />
            </Route>
            <Route path="/" exact>
                { !hasActiveEventForUser ? <Redirect to="/exhibitions" /> : <Pages.Home /> }
            </Route>
            <Route path="/stands/">
                <StandRoutes />
            </Route>
            { permission(me).has({ type: "craft_job", value: "view_job" }) &&
                <Route path="/jobs/" exact>
                    <Pages.Jobs.Collection />
                </Route>
            }
            <Route path="/crafts-overview" exact>
                <Pages.More.CraftsOverview />
            </Route>
            <Route path="/more/">
                <MoreRoutes />
            </Route>
            <Route path="*" >
                <Pages.Page404 />
            </Route>
        </Switch>
    );
};

export default AppRoutes;